
 

 

 

    import ACLTemplateSearchCriteria from 'Modules/Core/Scripts/ACLTemplateSearchCriteria';

    import PagingCriteria from 'Lib/Fs.Core.Data/PagingCriteria';

 
class ACLTemplateSearchParameter 
{
    
        Criteria: ACLTemplateSearchCriteria;
    
        PagingCriteria: PagingCriteria;
    
        SortingCriteria: any;
    
}
 
export default ACLTemplateSearchParameter;
 




